import { render, staticRenderFns } from "./ReportDataTable.vue?vue&type=template&id=734ec68e&scoped=true"
import script from "./ReportDataTable.vue?vue&type=script&lang=js"
export * from "./ReportDataTable.vue?vue&type=script&lang=js"
import style0 from "./ReportDataTable.vue?vue&type=style&index=0&id=734ec68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ec68e",
  null
  
)

export default component.exports